/** @jsx h **/

import { component, h, When } from "alfama";
import { ShellProps } from "../../@types";
import { LogoMenu } from "./LogoMenu";

export const HeaderIsland = component<ShellProps>(
  "HeaderIsland",
  (props, { signal, onMount, getContext }) => {
    return (
      <div style="left: 5px; top: 5px; z-index: 2147483647; " class={"fixed "}>
        <LogoMenu {...props} />
        <When
          condition={($) => {
            return props.session.user.anon ? "anon" : "logged";
          }}
          views={{
            loading: () => null,
            anon: () => {
              return null;
              //              return (
              //                <a
              //                  target="_blank"
              //                  href={`${hubHost}/auth/request`}
              //                  class="ml-1 btn btn-primary"
              //                >
              //                  <i class="ri-fingerprint-line"></i>
              //                  <span style="padding: 0 0 0 5px;">{" signup "}</span>
              //                </a>
              //              );
            },
            logged: () => {
              return null;
            },
          }}
        ></When>
      </div>
    );
  }
);
